<template>
  <div class="form--auth">
    <CustomLottie :animationData="animationData"></CustomLottie>
    <div class="sent__text-wrapper text-center mt-3">
      <h3>我們已向你傳送重設密碼的電郵</h3>
      <p>請查看您的電子郵件信箱，確認電郵有機會被錯誤分類至垃圾電郵箱(Spam)</p>
    </div>
    <b-button to="/login"
              variant="primary"
              size="lg"
              block
    >
      返回登入
    </b-button>
    <b-button class="btn--resend"
              variant="link"
              size="lg"
              block
              :disabled="!!counter"
              v-stream:click="resendEmail$"
    >
      重發電郵
      <span v-if="counter"> ({{ counter }})</span>
    </b-button>
  </div>
</template>

<script>
import { timer } from 'rxjs';
import {
  map,
  tap,
  take,
  filter,
  switchMap,
  startWith,
} from 'rxjs/operators';
import { BButton } from 'bootstrap-vue';
import CustomLottie from '@/components/CustomLottie.vue';
import animationData from '@/assets/lottie/email-sent.json';
import http from '../../helpers/http';

export default {
  components: {
    BButton,
    CustomLottie,
  },
  data: () => ({
    resendTime: 10,
    animationData,
  }),
  domStreams: ['resendEmail$'],
  subscriptions() {
    const countdown = () => timer(0, 1000)
      .pipe(
        take(this.resendTime + 1),
        map((i) => this.resendTime - i),
      );

    const resendEmail = () => http({
      method: 'POST',
      url: '/agc-merchant-api/auth/resend',
      data: { ref: this.$route.query.ref },
    });

    return {
      counter: this.resendEmail$
        .pipe(
          filter(() => typeof this.$route.query.ref !== 'undefined'),
          tap(resendEmail),
          startWith([]),
          switchMap(countdown),
        ),
    };
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/form--auth";
</style>

<style scoped lang="scss">
.sent {
  &__text-wrapper {
    & h3 {
      font-size: 18px;
      font-weight: 500;
      color: #3A4047;
      margin-bottom: 0.75rem;
    }

    & p {
      font-size: 15px;
      font-weight: 400;
      color: #636D77;
      margin-bottom: 2rem;
    }
  }
}

.btn {
  &--resend {
    &:hover, &:focus {
      text-decoration: none;
    }
  }
}
</style>
